import { memo, useState } from "react";
import styled from "styled-components";
import { UI_Header, UI_HeaderLeft, UI_HeaderRight, UI_HeaderRight_item } from "../PanelStyle";
import { FaXmark } from "react-icons/fa6";
import { PiShareNetworkBold } from "react-icons/pi";
import { showSharePanelAtom } from "../../stores/mapStore";
import { useAtom } from 'jotai';
import { Button, Input } from "antd";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";
import MemberItem from "./MemberItem/MemberItem";
import ShareProjectLink from "./ShareProjectlink/ShareProjectLink";

const SharePanel = () => {
  const [showSharePanel, setShowSharePanel] = useAtom<boolean>(showSharePanelAtom);

  return (
    <UI_Wrapper>
      {/* Header */}
      <UI_Header>
        <UI_HeaderLeft style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <PiShareNetworkBold style={{ color: '#2563eb', fontSize: '18px' }} />
          <span>Chia sẻ</span>
        </UI_HeaderLeft>
        <UI_HeaderRight>
          <UI_HeaderRight_item onClick={() => {
            setShowSharePanel(false);
          }}>
            <FaXmark />
          </UI_HeaderRight_item>
        </UI_HeaderRight>
      </UI_Header>
      {/* End Header */}

      {/* Content */}
      <UI_Content>
        <FormItemWrapper label="Email">
          <div style={{ display: 'flex', gap: 8 }}>
            <Input placeholder="Thêm người vào dự án" />
            <Button type="primary">Mời</Button>
          </div>
        </FormItemWrapper>

        {/* Danh sách thành viên */}
        <UI_List style={{ borderBottom: '1px solid #e0e0e0' }}>
          <MemberItem />
          <MemberItem />
          <MemberItem />
        </UI_List>
        {/* End Danh sách thành viên */}

        {/* Share project link */}
        <ShareProjectLink />
        {/* End Share project link */}
      </UI_Content>
      {/* End Content */}
    </UI_Wrapper>
  );
}

export default memo(SharePanel);

const UI_Wrapper = styled.div`
  width: 300px;
  height: 500px;
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 8px;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`;

const UI_Content = styled.div`
  padding: 16px;
`

const UI_List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
